import React, { forwardRef } from 'react';
import {} from '../icon/index.js';
import { StyledAppendix, StyledSelect, StyledLabel, StyledSelectField, StyledFormMessage, StyledSelectContainer, StyledIcon, StyledChevron } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const SelectField = forwardRef(({ appendix, children, disabled, errorMessage, hint, icon, id, invalid, label, name, onBlur, onChange, onFocus, required, value, margin, className, readOnly, autoComplete, ...rest }, ref) => {
    const hintId = `${id}__hint`;
    const errorMessageId = `${id}_errorMessageId`;
    const empty = !value;
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const ariaDescribedBy = hint || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledSelectField, { margin: margin, className: className, ...pickDataProps(rest) },
        React.createElement(StyledLabel, { htmlFor: id, "$disabled": disabled },
            label,
            appendix && (React.createElement(StyledAppendix, { "$disabled": disabled }, appendix))),
        React.createElement(StyledSelectContainer, null,
            icon && React.createElement(StyledIcon, { name: icon, size: "s", "$disabled": disabled }),
            React.createElement(StyledSelect, { name: name, id: id, ref: ref, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, disabled: disabled || readOnly, required: required, autoComplete: autoComplete, ...pickA11yProps(rest), "aria-invalid": invalid, "aria-describedby": ariaDescribedBy, "aria-errormessage": errorMessage ? errorMessageId : undefined, icon: icon, invalid: invalid, "$readOnly": readOnly, "$empty": empty }, children),
            !readOnly && (React.createElement(StyledChevron, { className: "arrow", name: "arrow-down", size: "s", "$disabled": disabled, "aria-hidden": "true" }))),
        hint && (React.createElement(StyledFormMessage, { text: hint, variant: "hint", id: hintId, disabled: disabled })),
        invalid && !disabled && errorMessage && (React.createElement(StyledFormMessage, { text: errorMessage, variant: "error", id: errorMessageId }))));
});
SelectField.displayName = 'SelectField';
//# sourceMappingURL=index.js.map